import {gsap} from "../../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {HarponTile} from "./HarponTile";

// Constructor
export class SolidHarponTile extends HarponTile {

  constructor(rowIndex, colIndex) {
    super(rowIndex, colIndex);

    this.isValidMove = true;
    this.type = "solid";

    this.build();
  }

  build() {
    super.build();

    this.testedTile = new PIXI.Sprite(app.game.assets["tile-solid"]);
    this.testedTile.alpha = 0;
    this.addChild(this.testedTile);
  }

  test() {
    this.testCounts++;

    if (this.testCounts >= 3) {
      this.show();
      app.audio.play(app.data.global.sounds.test_ice, 1.0, true);
      app.audio.play(app.data.global.sounds.good_ice, 1.0, true);
    } else {
      app.audio.play(app.data.global.sounds.test_ice, 1.0, true);
    }
  }

  show() {
    this.shown = true;

    gsap.to(this.testedTile, {
      pixi: {
        alpha: 1
      },
      duration: 0.5,
      ease: "power1.inOut",
    })
  }

  endOfTurnAction() {
    // if (this.playerIsOnTile()) {
    //  console.log("player is on", this, app.game.player.currentTile)
    // }
  }

  // Reset the states so we can animate in again and start over
  reset() {
  }


}
